<template>
  <div>
    <div>
      <div class="page page-current page-goods" :style="{'z-index':'1'}" @touchmove.prevent v-if="preventTouchMoveFlag">
        <!--返回-->
        <header class="bar bar-nav" v-if="isDeskFlag" style="background-color: #0894ec;">
          <a class="icon icon-left pull-left color-wt" @click="goBack" v-if="!isHomepage"></a>
          <h1 class="title color-wt">吉凯淘基因</h1>
        </header>

        <!-- 工具栏 -->
        <nav v-if="navTopLevel && !isWapp" class="bar bar-tab" style="background-color: #F3F3F3;height: 2.6rem;position: fixed">
<!--          <router-link class="tab-item" :to="{ name: 'home'}" :class="{'sales': isSalesFlag}">-->
<!--            <span class="icon icon-home"></span>-->
<!--            <span class="tab-label">促销信息</span>-->
<!--          </router-link>-->
<!--          <router-link class="tab-item" :to="{ name: 'category'}" :class="{'sales': isSalesFlag}">-->
<!--            <span class="icon icon-app"></span>-->
<!--            <span class="tab-label">产品导航</span>-->
<!--          </router-link>-->
          <!--<a href="#/news" class="tab-item" v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.onBehalfOfCustomer === 0" >-->
          <!--<span class="icon icon-browser"></span>-->
          <!--<span class="tab-label">干货</span>-->
          <!--</a>-->
          <!--<a href="#/news" class="tab-item" v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.onBehalfOfCustomer === 0" >-->
          <!--<a href="#/news" class="tab-item"  v-if="sessionInfo.ssoFlag === 0">-->
          <!--<span class="icon icon-browser"></span>-->
          <!--<span class="tab-label">资讯</span>-->
          <!--</a>-->
          <!--<router-link class="tab-item" :to="{ name: 'newsShare'}"  v-if="sessionInfo.ssoFlag === 0">-->
          <!--<span class="icon icon-browser"></span>-->
          <!--<span class="tab-label">资讯</span>-->
          <!--</router-link>-->
          <!-- v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.onBehalfOfCustomer === 1" -->
          <router-link class="tab-item" :to="{ name: 'custOrder'}" :class="{'sales': isSalesFlag}"  v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.onBehalfOfCustomer === 1">
            <span class="icon icon-edit"></span>
            <span class="tab-label">定制</span>
          </router-link>
          <router-link class="tab-item" :to="{ name: 'cart'}" :class="{'sales': isSalesFlag}">
            <span class="icon icon-cart"></span>
            <span class="tab-label">购物车</span>
            <span class="badge" v-if = "getTotalGoodsNum > 0">{{getTotalGoodsNum}}</span>
          </router-link>
          <router-link class="tab-item" :to="{ name: 'me' }" :class="{'sales': isSalesFlag}">
            <span class="icon icon-me"></span>
            <span class="tab-label">我的</span>
            <span v-if = "waitPaidAndDeliver > 0"
                  class="badge">{{waitPaidAndDeliver}}
      </span>
          </router-link>
        </nav>

        <!-- 这里是页面内容区 -->
        <div class="content" style="margin-bottom: -1rem;height: 94%;" v-if="isDeskFlag">
          <transition name="fade" mode="out-in" keep-alive>
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
          </transition>
          <transition name="fade" mode="out-in" keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
          </transition>
        </div>
        <div v-else>
          <transition name="fade" mode="out-in" keep-alive>
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
          </transition>
          <transition name="fade" mode="out-in" keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
          </transition>
        </div>
        <customer-service v-if="!isDeskFlag  && !hideCustomerService" @preventTouchMove="handlePreventTouchMove" @activateTouchMove="handleActivateTouchMove"></customer-service>
      </div>
      <div class="page page-current page-goods" :style="{'z-index':'1'}" v-else>
        <!--返回-->
        <header class="bar bar-nav" v-if="isDeskFlag" style="background-color: #0894ec;">
          <a class="icon icon-left pull-left color-wt" @click="goBack" v-if="!isHomepage"></a>
          <h1 class="title color-wt">吉凯淘基因</h1>
        </header>

        <!-- 工具栏 -->
        <nav v-if="navTopLevel && !isWapp" class="bar bar-tab" style="background-color: #F3F3F3;height: 2.6rem;position: fixed">
<!--          <router-link class="tab-item" :to="{ name: 'home'}" :class="{'sales': isSalesFlag}">-->
<!--            <span class="icon icon-home"></span>-->
<!--            <span class="tab-label">促销信息</span>-->
<!--          </router-link>-->
<!--          <router-link class="tab-item" :to="{ name: 'category'}" :class="{'sales': isSalesFlag}">-->
<!--            <span class="icon icon-app"></span>-->
<!--            <span class="tab-label">产品导航</span>-->
<!--          </router-link>-->
          <!--<a href="#/news" class="tab-item" v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.onBehalfOfCustomer === 0" >-->
          <!--<span class="icon icon-browser"></span>-->
          <!--<span class="tab-label">干货</span>-->
          <!--</a>-->
          <!--<a href="#/news" class="tab-item" v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.onBehalfOfCustomer === 0" >-->
          <!--<a href="#/news" class="tab-item"  v-if="sessionInfo.ssoFlag === 0">-->
          <!--<span class="icon icon-browser"></span>-->
          <!--<span class="tab-label">资讯</span>-->
          <!--</a>-->
          <!--<router-link class="tab-item" :to="{ name: 'newsShare'}"  v-if="sessionInfo.ssoFlag === 0">-->
          <!--<span class="icon icon-browser"></span>-->
          <!--<span class="tab-label">资讯</span>-->
          <!--</router-link>-->
          <!-- v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.onBehalfOfCustomer === 1" -->
          <router-link class="tab-item" :to="{ name: 'custOrder'}" :class="{'sales': isSalesFlag}"  v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.onBehalfOfCustomer === 1">
            <span class="icon icon-edit"></span>
            <span class="tab-label">定制</span>
          </router-link>
          <router-link class="tab-item" :to="{ name: 'cart'}" :class="{'sales': isSalesFlag}">
            <span class="icon icon-cart"></span>
            <span class="tab-label">购物车</span>
            <span class="badge" v-if = "getTotalGoodsNum > 0">{{getTotalGoodsNum}}</span>
          </router-link>
          <router-link class="tab-item" :to="{ name: 'me' }" :class="{'sales': isSalesFlag}">
            <span class="icon icon-me"></span>
            <span class="tab-label">我的</span>
            <span v-if = "waitPaidAndDeliver > 0"
                  class="badge">{{waitPaidAndDeliver}}
      </span>
          </router-link>
        </nav>

        <!-- 这里是页面内容区 -->
        <div class="content" style="margin-bottom: -1rem;height: 94%;" v-if="isDeskFlag">
          <div v-if="isWapp && !isPcUser && showBack" @click="goBack" class="back-text"><img :src="backUrl" :data-src="backUrl"/>
          </div>          <transition name="fade" mode="out-in" keep-alive>
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
          </transition>
          <transition name="fade" mode="out-in" keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
          </transition>
        </div>
        <div v-else>
          <div v-if="isWapp && !isPcUser && showBack" @click="goBack" class="back-text"><img :src="backUrl" :data-src="backUrl"/>
          </div>
          <transition name="fade" mode="out-in" keep-alive>
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
          </transition>
          <transition name="fade" mode="out-in" keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
          </transition>
        </div>
        <customer-service v-if="!isDeskFlag && !hideCustomerService" @preventTouchMove="handlePreventTouchMove" @activateTouchMove="handleActivateTouchMove"></customer-service>
      </div>
    </div>
  </div>
</template>

<script>
  import wx from 'wx'
  import {mapState, mapMutations, mapGetters} from 'vuex'
  import $ from 'jquery'
  import EMKT from './emkt'
  import CustomerService from './views_v_2.6/components/CustomerService'
export default {
    components: {
      CustomerService
    },
    name: 'app',
    data () {
      return {
        isWapp: EMKT.isWapp,
        preventTouchMoveFlag: false,
        isPcUser: null,
        backUrl: '/static/img/svg/返回上一页面.svg',
        showBack: false
      }
    },
    created: function () {
      // 微信配置
      wx.config({
        debug: false,
        appId: $.sign.appId,
        timestamp: $.sign.timestamp,
        nonceStr: $.sign.nonceStr,
        signature: $.sign.signature,
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'onMenuShareWeibo'
        ]
      })
      EMKT.wxShare()
      this.INIT_CART()
      console.log('Emkt.isWapp', this.isWapp)
      // 在需要配置分享内容的时候调用
      // wxShareConfig()
    },
    computed: {
      ...mapState([
        // 映射 this.navTopLevel 为 store.state.navTopLevel
        'navTopLevel', 'cartList', 'sessionInfo', 'myOrder', 'researchGroupSet', 'gotoCart', 'customerOpenId'
      ]),
      ...mapGetters([
      // 映射 this.navTopLevel 为 store.state.navTopLevel
        'hasLogin', 'isSFFlag', 'customerNo', 'hideCustomerService'
      ]),
      getTotalGoodsNum () {
        var self = this
        let number = 0
        for (let key in self.cartList.cartContent) {
          if (self.cartList.cartContent[key].productQuantity) {
            number = number + self.cartList.cartContent[key].productQuantity
          } else {
            number = number + 1
          }
        }
        return number
      },
      isSalesFlag () {
        let flag = false
        let cInfo = this.sessionInfo.customerInfo
        if (cInfo) {
          if (cInfo.onBehalfOfCustomer === 1) {
            flag = true
          }
        }
        return flag
      },
      isDeskFlag () {
        return EMKT.isDesktop
      },
      isHomepage () {
        return this.$route.name === 'home'
      },
      waitPaidAndDeliver () {
        const orders = this.myOrder
        if (!orders) {
          return 0
        }
        if (!orders.waitDeliverOrders && orders.waitPaidOrders) {
          return orders.waitPaidOrders.length
        }
        if (orders.waitDeliverOrders && !orders.waitPaidOrders) {
          return orders.waitDeliverOrders.length
        }
        if (orders.waitDeliverOrders && orders.waitPaidOrders) {
          return orders.waitDeliverOrders.length + orders.waitPaidOrders.length
        }
        return 0
      }
    },
    mounted () {
      this.isPcUser = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      // if (this.isPcUser) {
      //   alert('手机用户')
      // } else {
      //   alert('PC用户')
      // }
      // new DragUtil(hottarget, target)
      // this.getSessionID()
    },
    watch: {
       // TODO 初始化购物车逻辑
      'hasLogin': {
        handler: 'getNonSalesforceShoppingCart',
        immediate: true
      },
      'cartList': 'saveCartList',
      'researchGroupSet': {
        handler: 'remindOverdueBill'
      },
      $route (to, from) {
        if (window.history.length < 2) {
          this.showBack = false
        } else {
          this.showBack = true
        }
      }
    },
    methods: {
      ...mapMutations([
        'INIT_CART', 'COMBINE_CART_LIST', 'UPDATE_SAVE_TO_DB_OR_LOCALSTORAGE', 'SET_CART_LIST'
      ]),
      handlePreventTouchMove () {
        this.preventTouchMoveFlag = true
      },
      handleActivateTouchMove () {
        this.preventTouchMoveFlag = false
      },
      goBack () {
        window.history.back()
        console.log(this.$router.history, window.history, 'siaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
      },
      getNonSalesforceShoppingCart (val) {
        if (val === undefined) {
          console.log('hasLogin has not been initialized')
          return
        }
        if (this.isSFFlag === true) {
          return
        }
        if (val === false && !EMKT.isWappGuest) {
          this.UPDATE_SAVE_TO_DB_OR_LOCALSTORAGE(false)
          return
        }
        if (EMKT.isWappGuest) {
          this.gcapi('getWappGuestShoppingCart', this.customerOpenId).then(res => {
            if (res && res.body.code === 0) {
              let cart
                    // DB中无购物车记录或者记录为空{}
              if (!res.body.result || !res.body.result.cartContent || res.body.result.cartContent === '{}') {
                cart = '{}'
              } else {
                cart = res.body.result.cartContent
              }
              this.SET_CART_LIST(JSON.parse(cart))
            }
          })
        } else {
          this.gcapi('getNonSalesforceShoppingCart', this.sessionInfo.customerInfo.customerNo).then(res => {
            if (res && res.body.code === 0) {
              let cart
                    // DB中无购物车记录或者记录为空{}
              if (!res.body.result || !res.body.result.cartContent || res.body.result.cartContent === '{}') {
                cart = '{}'
              } else {
                cart = res.body.result.cartContent
              }
                    // 从小程序跳转过来，仅读取数据库购物车数据
              if (this.isWapp) {
                this.SET_CART_LIST(JSON.parse(cart))
              } else if (EMKT.getUrlParamHref('fromSmart') === '1') {
                this.SET_CART_LIST(JSON.parse(cart))
              } else {
                this.COMBINE_CART_LIST(cart)
              }
            }
          })
        }
      },
      saveCartList (val) {
        let that = this
        // 防止cartList为null时，清空购物车
        if (!val || !val.cartContent) return
          // SF需手动保存购物车
        if (this.isSFFlag === true) {
          console.log('isSFFlag is true')
          return
        }
        // TODO 购物车保存逻辑
          // 游客保存在本地
        if (val.saveToDBOrLocalStorage === false) {
          console.log('游客登录状态 购物车存储在本地')
          EMKT.setLocalStorage('EmktBuyCart', val.cartContent)
          return
        }
        console.log(val.cartContent, '购物数据AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA')
          // 顾客保存在数据库
        const cartJsonString = JSON.stringify(val.cartContent)
        // $.showPreloader('正在处理数据')
        if (localStorage.getItem('saveToCart')) {
          this.$weui.loading('正在处理数据~')
        }
        if (EMKT.isWappGuest) { // 小程序游客模式根据openID获取数据
          this.gcapi('saveWappGuestShoppingCart', {openId: this.customerOpenId, cartContent: cartJsonString})
              .then(function (response) {
                if (response.body.code === 0) {
                  if (localStorage.getItem('saveToCart')) {
                    that.$weui.loading().hide()
                    localStorage.removeItem('saveToCart')
                    that.$weui.toast('商品加入成功！', 500)
                  }
                } else {
                  $.showPreloader('保存失败！')
                  setTimeout(function () {
                    $.hidePreloader()
                  }, 1000)
                }
              })
        } else {
          this.gcapi('saveShoppingCart', cartJsonString).then(function (response) {
            if (response.body.code === 0) {
              if (localStorage.getItem('saveToCart')) {
                that.$weui.loading().hide()
                localStorage.removeItem('saveToCart')
                that.$weui.toast('商品加入成功！', 500)
              }
            } else {
              $.showPreloader('保存失败！')
              setTimeout(function () {
                $.hidePreloader()
              }, 1000)
            }
          })
        }
      },
      remindOverdueBill (val) {
        if (!this.hasLogin) {
          return
        }
        if (!val || val.length === 0) {
          console.log('researchGroupSet is empty')
          return
        }
        const remindOverdueBillAlready = EMKT.getLocalStorage('remindOverdueBillAlready')
        if (remindOverdueBillAlready) {
          console.log('remind overdue bill already')
          return
        }
        const freezedResearchGroup = val.filter(group => (this.customerNo === group.leaderNo && group.status === EMKT.RESEARCH_GROUP_STATUS_LOCKED))
        if (freezedResearchGroup.length === 0) {
          return
        }
        const name = this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.customerName
        let remindText = name + '老师，您好，您的某月账单已逾期尚未结清，目前课题组账户已冻结，请您尽快结清账款。如有疑问，请联系业务人员或致电客服热线400-621-0302'
        $.alert(remindText)
        EMKT.setStoreItem('remindOverdueBillAlready', true)
      }
//      ,
//      getSessionID () {
//        // obtaining guest sessinid by an anonymous request
//        var _this = this
//        _this.gcapi('gcwwwifc/login', {
//          'LoginId': 'XX',
//          'Password': 'XX',
//          'Access_Token': 'XX'
//        })
//        if (!EMKT.getLocalStorage('EmktFirstLevelEnterpriseList')) {
//          _this.gcapi('gcwwwifc/listEnterprise').then((response) => {
//            EMKT.setLocalStorage('EmktFirstLevelEnterpriseList', response.body['result'])
//          })
//        }
//      }
    }
    /*
    data () {
      return {
        isIndex: this.Emkt.navTopLevel
      }
    }
    */
  }
</script>

<style>
  /*防止weui修改placeholder样式*/
  ::-webkit-input-placeholder{
    color:#929292!important;
  }
  input, textarea {
    -webkit-user-select:auto; /*webkit浏览器*/
    user-select:auto;
    -o-user-select:auto;
    -ms-user-select:auto;
  }
  /*
  @import '../static/lib/light7-0.4.3/css/light7.css';
  @import '../static/lib/light7-0.4.3/css/light7-swipeout.css';
  @import '../static/lib/light7-0.4.3/css/light7-swipeout.css';
  */
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  .tab-item.router-link-active.sales {
    color:#FEFEFE;
    background-color: #f6383a;
  }
  .tab-item.router-link-active {
    color:#FEFEFE;
    background-color: #003D8E;
  }

  [v-cloak] {
    display: none;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s ease;
  }
  .fade-enter, .fade-leave-active {
    opacity: 0
  }
  .color-wt{
     color: #ffffff;
  }
  .back-text {
    width: 100%;
    height: 33px;
    background: #FFFFFF;
    padding: 5px 0 10px 5px;
  }
  div {
    /*-webkit-overflow-scrolling: touch; !*webkit浏览器*!*/
    /*overflow: auto;*/
    /*overflow-y: scroll;*/
  }
</style>



// WEBPACK FOOTER //
// App.vue?76c0c3de